import { RQAPICallWithData } from 'store/APIClient';
import { useQuery } from '@tanstack/react-query';

export const useGetAllSoftwares = () =>
    useQuery({
        queryKey: ['all-softwares'],

        queryFn: async () => {
            const response = await RQAPICallWithData<Record<string, string[]>>({
                endpoint: `integrations/all_softwares`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
